import Tile from "../Tile/Tile"
import ChartWrapper from "./Wrappers/ChartWrapper"

export default function ChartTile({
  tile,
  isTemplate,
  emptyMessage,
  tileSettingsModal,
  canEdit = true,
}) {
  const { id, name, kind, data, y_axis_label } = tile

  const hasFields = tile.group_field_id || tile.weight_field_id
  const hasChartData = !isTemplate && data?.detail.length > 0
  const hasRealChartData = hasFields && hasChartData
  const canShowChart = isTemplate || hasRealChartData
  const chartData = isTemplate ? tile.getDummyChartData() : data.detail
  const yAxisLabel = y_axis_label

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const emptyMessageTemplate = () => (
    <div className="flex h-full items-center justify-center px-10 py-0 text-center italic text-neutral-7">
      {emptyMessage}
    </div>
  )

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={id}
      title={name}
      canEdit={canEdit}
    >
      {canShowChart ? (
        <ChartWrapper kind={kind} data={chartData} yAxisLabel={yAxisLabel} />
      ) : (
        emptyMessageTemplate()
      )}
    </Tile>
  )
}
